import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { navLinks } from '../mock';
import Logo from './Logo';

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleClick = (href) => (e) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#F7F4EA]/95 backdrop-blur-md shadow-[0_4px_30px_-15px_rgba(77,77,77,0.25)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between gap-4">
        <a
          href="#home"
          onClick={handleClick('#home')}
          className="flex-shrink-0"
          aria-label="Veetu Saama home"
        >
          <Logo variant="full" theme="dark" size={38} showTagline={false} />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={handleClick(l.href)}
              className="relative text-[13px] uppercase tracking-[0.22em] font-semibold text-[#1a1410] hover:text-[#F58220] transition-colors duration-300 group"
            >
              {l.label}
              <span className="absolute -bottom-2 left-0 w-0 h-[2px] bg-[#F58220] group-hover:w-full transition-all duration-500" />
            </a>
          ))}
        </nav>

        <div className="hidden xl:flex items-center gap-4">
          <a
            href="tel:+917305970386"
            className="flex items-center gap-2 text-[13px] font-medium text-[#4D4D4D] hover:text-[#F58220] transition-colors whitespace-nowrap"
          >
            <Phone className="w-4 h-4" strokeWidth={2} />
            +91 73059 70386
          </a>
          <a
            href="#contact"
            onClick={handleClick('#contact')}
            className="btn-primary px-6 py-2.5 rounded-full text-[11px] uppercase tracking-[0.24em] whitespace-nowrap"
          >
            Visit Store
          </a>
        </div>

        <div className="hidden lg:flex xl:hidden">
          <a
            href="#contact"
            onClick={handleClick('#contact')}
            className="btn-primary px-5 py-2.5 rounded-full text-[11px] uppercase tracking-[0.22em] whitespace-nowrap"
          >
            Visit Store
          </a>
        </div>

        <button
          className="lg:hidden text-[#1a1410] p-2"
          onClick={() => setOpen(!open)}
          aria-label="menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 bg-[#F7F4EA] ${
          open ? 'max-h-[500px]' : 'max-h-0'
        }`}
      >
        <nav className="flex flex-col p-6 gap-5">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={handleClick(l.href)}
              className="text-[14px] uppercase tracking-[0.24em] font-semibold text-[#1a1410] hover:text-[#F58220]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={handleClick('#contact')}
            className="btn-primary px-5 py-3 rounded-full text-[11px] uppercase tracking-[0.24em] text-center mt-2"
          >
            Visit Store
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
